/* @flow */
import React from 'react';

import ChatMessage from 'entities/ChatMessage';
import ChatMessageSnippet from './ChatMessageSnippet.jsx';
import Text from 'components/Text.jsx';
import Glyph from 'components/Glyph.jsx';

import ChatMessageTimestamp from './ChatMessageTimestamp.jsx';
import ChatTitle from './ChatTitle.jsx';

const chatDisabledGlyph = (
  <Glyph
    className="ChatListItem-disabledGlyph"
    name="chat-mute"
    size="xsmall"
    color="eclipse"
  />
);

type Props = {
  avatar: any,
  isDisabled: ?boolean,
  lastMessage: ?ChatMessage,
  title: ?string,
  query: ?string,
  timestamp: Date,
};

export class ChatListItemContentConversation extends React.Component {
  props: Props;

  render() {
    const {
      avatar,
      isDisabled,
      lastMessage,
      title,
      query,
      timestamp,
    } = this.props;

    const snippet = lastMessage ?
      <ChatMessageSnippet message={lastMessage} /> :
      <br />;

    return (
      <div className="ChatListItem-content">
        <div className="ChatListItem-content-droplet">{avatar}</div>
        <div className="ChatListItem-content-body">
          <div className="ChatListItem-content-body-inner">
            <div className="ChatListItem-content-body-inner-title">
              <Text color="pitch">
                <ChatTitle title={title} query={query} />
              </Text>
              {isDisabled && chatDisabledGlyph}
            </div>
            <ChatMessageTimestamp timestamp={timestamp} className="ChatListItem-date" />
          </div>
          <Text className="ChatListItem-snippet" truncate>{snippet}</Text>
          <hr className="ChatListItem-content-body-divider" />
        </div>
      </div>
    );
  }
}

export default ChatListItemContentConversation;



// WEBPACK FOOTER //
// ./src/chat/components/ChatListItemContentConversation.jsx